// Custom JS/jQuery add here

// if (window.location.href.indexOf("product") > -1) {}
// if (/products/.test(window.location.href)){}

if (window.matchMedia('(max-width: 768px)').matches) {
    var elem = document.querySelector('.custom_product-slideshow');
    var flkty = new Flickity( elem, {
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false 
    });
   var progressBar = document.querySelector('.progress-bar')
   flkty.on( 'scroll', function( progress ) {
      progress = Math.max( 0, Math.min( 1, progress ) );       
      progressBar.style.width = progress * 100 + '%';       
   });
}

// Announcement bar scrolling effect start: Ticker
var flktyAnnouncement;
var flktyMarqueeSpeedAdjustment = 1.5;
if(window.screen.width < 769){
  flktyMarqueeSpeedAdjustment = 0.7;
}

function update(){
  flktyAnnouncement.x = (flktyAnnouncement.x - flktyMarqueeSpeedAdjustment) % flktyAnnouncement.slideableWidth;
  flktyAnnouncement.settle(flktyAnnouncement.x);
  window.requestAnimationFrame(update);
}

// const listCount = document.getElementById('AnnouncementSlider1').getElementById('.announcement-slider__slide');
const announcementListCount = document.getElementById('AnnouncementSlider1').getElementsByTagName('div');

// if(announcementListCount.length > 2){
var announcementSlider = document.querySelector('#AnnouncementSlider1');
flktyAnnouncement = new Flickity( announcementSlider, {
  autoPlay: false,  
  pageDots: false,
  wrapAround: true,
  prevNextButtons: false  
});
flktyAnnouncement.x = 0;
  update();
// }

// Announcement bar scrolling effect Ends

// Adding class when hover on menu items
// $(".is-light .site-header .site-nav__item").hover(
$(".is-light .site-header").hover(
  function () {
    $(".is-light .site-header").addClass("focused-menu");
  },
  function () {
    $(".is-light .site-header").removeClass("focused-menu");
  }
);

// Pages Sticky tabs
$(window).scroll(function() {
  var headerHeight = $('header').outerHeight();
    if($('.site-header').hasClass("site-header--stuck")){
      $(".page-full.page_tab_menus, .template-collection .boost-pfs-filter-left-col.grid__item.medium-up--one-fifth, div#boost-pfs-filter-tree2[data-is-mobile]")
        .css({"position": "sticky", "top": headerHeight, "background": "#fff" });
    }else{
      $(".page-full.page_tab_menus, .template-collection .boost-pfs-filter-left-col.grid__item.medium-up--one-fifth, div#boost-pfs-filter-tree2[data-is-mobile]")
        .css({"position": "relative", "top": "0" });
    }
});

// var width = $(window).width();
// if (width < 769){
//   var collectionFilter = document.querySelector('.template-collection .filter-form ul.tag-list');
//   var collectionFilterFlkty = new Flickity( collectionFilter, {
//     cellAlign: 'left',
//     wrapAround: false,
//     pageDots: false,
//     prevNextButtons: false
//   });
// }
// setTimeout( function(){  }, 500);


// ----------------------------------
// Free Shipping Progress + Free Gift
// (Impulse / Archetype)
// ----------------------------------
let giftBusy = false;

// ----------------------------
// Helpers
// ----------------------------
function isSupportedCountry(wrapper) {
  const allowed = (wrapper.dataset.supportedCountries || "")
    .split(",")
    .map(s => s.trim().toUpperCase())
    .filter(Boolean);

  const country = (wrapper.dataset.country || "").toUpperCase();

  // If merchant leaves setting empty → allow all
  if (!allowed.length) return true;

  return allowed.includes(country);
}

function getGiftHandles(wrapper) {
  return parseHandles(wrapper.dataset.giftHandles);
}

function ensureGiftAccordion(chooser) {
  const toggle = chooser.querySelector(".gift-chooser__toggle");
  const panel = chooser.querySelector(".gift-chooser__panel");
  if (!toggle || !panel || toggle.__bound) return;

  toggle.__bound = true;

  toggle.addEventListener("click", () => {
    const isOpen = chooser.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.hidden = !isOpen;
  });

  // Default open
  chooser.classList.add("is-open");
  toggle.setAttribute("aria-expanded", "true");
  panel.hidden = false;
}

// Shopify money tokens -> [decimals, thousands separator, decimal separator].
// Covers every format Shopify can emit (SEK uses amount_with_space_separator,
// CHF can use the apostrophe one); an unknown token falls back to "amount"
// instead of leaking the raw {{placeholder}} into the cart.
var CRO_MONEY_TOKENS = {
  amount: [2, ",", "."],
  amount_no_decimals: [0, ",", "."],
  amount_with_comma_separator: [2, ".", ","],
  amount_no_decimals_with_comma_separator: [0, ".", ","],
  amount_with_apostrophe_separator: [2, "'", "."],
  amount_no_decimals_with_space_separator: [0, "\u00a0", ","],
  amount_with_space_separator: [2, "\u00a0", ","],
  amount_with_period_and_space_separator: [2, "\u00a0", "."]
};

function formatMoney(cents, format) {
  const fmt = format || "{{amount}}";
  const amount = cents / 100;

  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
    const spec = CRO_MONEY_TOKENS[token] || CRO_MONEY_TOKENS.amount;
    const parts = amount.toFixed(spec[0]).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, spec[1]);
    return parts.join(spec[2]);
  });
}

function parseMap(str) {
  const map = {};
  (str || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((pair) => {
      const [k, v] = pair.split(":");
      const num = parseFloat(v);
      if (k && Number.isFinite(num)) map[k.toUpperCase()] = num;
    });
  return map;
}

function getMultiplier(currency) {
  return ["JPY","KRW","CLP","HUF","TWD"].includes(currency) ? 1 : 100;
}

// the gift stage where there is no free shipping (no threshold for the
// currency, international since 30-10): the theme-setting messages all
// start with "FREE SHIPPING"
var CRO_GIFT_ONLY_MID = "Spend [remaining_for_goal] for a FREE GIFT...";
var CRO_GIFT_ONLY_POST = "FREE GIFT UNLOCKED!";

function resolveThreshold(wrapper, datasetKey, currency) {
  const cur = (currency || "").toUpperCase();
  const map = parseMap(wrapper.dataset[datasetKey]);

  const countrySupported = isSupportedCountry(wrapper);

  // If country NOT supported → always use INT (if present)
  if (!countrySupported) {
    const intlMajor = map["INT"];
    if (!Number.isFinite(intlMajor)) return null;

    // INT values are written in "major" units like 350.00 -> minor units
    return Math.round(intlMajor * getMultiplier(cur || "USD"));
  }  

  // Country supported → use currency map
  const major = map[cur];
  if (!Number.isFinite(major)) return null;

  return Math.round(major * getMultiplier(cur));
}

function parseHandles(str) {
  return (str || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

function isGiftLine(item) {
  if (!item || !item.properties) return false;
  const v = item.properties._free_gift;
  return v === true || v === "true" || v === 1 || v === "1";
}

function findGift(cart) {
  return (cart.items || []).find(isGiftLine) || null;
}

// Exclude gift from totals so the gift can’t keep itself eligible
function getCartTotalExcludingGift(cart) {
  const gift = findGift(cart);
  if (!gift) return cart.total_price;
  return cart.total_price - (gift.final_line_price || 0);
}

// Threshold markers
function formatMoneyMarker(cents, format) {
  if (!Number.isFinite(cents)) return "";

  // Same token handling as formatMoney (every Shopify money format)
  let formatted = formatMoney(cents, format);

  // Strip HTML wrappers (Impulse dualPrice etc)
  const tmp = document.createElement("div");
  tmp.innerHTML = formatted;
  formatted = tmp.textContent || tmp.innerText || formatted;

  // Remove trailing zero decimals (",00" / ".00") — only the decimal part
  formatted = formatted.replace(/[.,]00(?=\D*$)/, "");

  return formatted.trim();
}

function updateProgressMarkers(wrapper, shipThresholdMinor, giftThresholdMinor, moneyFormat) {
  const markersWrap = wrapper.querySelector(".cart-progress-markers");
  if (!markersWrap) return;

  const shipMarker = markersWrap.querySelector(".cart-progress-marker--ship");
  const giftMarker = markersWrap.querySelector(".cart-progress-marker--gift");
  const shipLabel = shipMarker && shipMarker.querySelector(".cart-progress-marker__label");
  const giftLabel = giftMarker && giftMarker.querySelector(".cart-progress-marker__label");

  const hasGift = Number.isFinite(giftThresholdMinor) && giftThresholdMinor > 0;

  // If no gift stage, ship is the "end"
  const max = hasGift ? giftThresholdMinor : shipThresholdMinor;

  if (!Number.isFinite(max) || max <= 0) {
    markersWrap.style.display = "none";
    return;
  }

  markersWrap.style.display = "";

  // Show/hide gift marker
  if (giftMarker) giftMarker.style.display = hasGift ? "" : "none";
  // threshold 0 = free shipping on every order: no shipping mark on the bar
  if (shipMarker) shipMarker.style.display = shipThresholdMinor === 0 ? "none" : "";

  // Positions
  const shipPct = Math.max(0, Math.min((shipThresholdMinor / max) * 100, 100));
  if (shipMarker) shipMarker.style.left = `${shipPct}%`;

  // Labels
  if (shipLabel) shipLabel.textContent = formatMoneyMarker(shipThresholdMinor, moneyFormat);

  if (giftLabel) {
    giftLabel.textContent = hasGift
      ? formatMoneyMarker(giftThresholdMinor, moneyFormat)
      : "";
  }
}

// ----------------------------
// Cart API
// ----------------------------
function cartChange(lineKey, quantity) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity }),
  }).then((r) => r.json());
}

function addGift(variantId) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { _free_gift: "true" },
    }),
  }).then((r) => r.json());
}

// ----------------------------
// Gift UI
// ----------------------------
function bindGiftSlider(wrapper) {
  const options = wrapper.querySelector(".gift-chooser__options");
  const nav = wrapper.querySelector(".gift-chooser__nav");
  const prev = wrapper.querySelector(".gift-chooser__arrow--prev");
  const next = wrapper.querySelector(".gift-chooser__arrow--next");

  if (!options || !prev || !next) return;

  // Bind click handlers once per wrapper
  if (!wrapper.__sliderBound) {
    wrapper.__sliderBound = true;

    const scrollByCard = () => {
      const card = options.querySelector(".gift-chooser__card");
      // +10 matches your gap
      return card ? card.getBoundingClientRect().width + 10 : 220;
    };

    prev.addEventListener("click", () => {
      options.scrollBy({ left: -scrollByCard(), behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      options.scrollBy({ left: scrollByCard(), behavior: "smooth" });
    });
  }

  const updateUI = () => {
    // Do we actually overflow?
    const maxScroll = options.scrollWidth - options.clientWidth;
    const hasOverflow = maxScroll > 1;

    // Show/hide nav only if needed
    if (nav) nav.hidden = !hasOverflow;

    if (!hasOverflow) {
      // reset states
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    // Enable/disable based on current scroll
    prev.disabled = options.scrollLeft <= 0;
    next.disabled = options.scrollLeft >= maxScroll - 1;
  };

  // Bind listeners once
  if (!options.__sliderListenersBound) {
    options.__sliderListenersBound = true;
    options.addEventListener("scroll", updateUI);
    window.addEventListener("resize", () => {
      // Wait a tick for layout to settle
      requestAnimationFrame(updateUI);
    });
  }

  // Run after render/layout
  requestAnimationFrame(() => {
    updateUI();
  });
}

function updateGiftUI(wrapper, cart, currency) {
  const chooser = wrapper.querySelector(".gift-chooser");
  const options = wrapper.querySelector(".gift-chooser__options");
  if (!chooser || !options) return;

  const giftHandles = getGiftHandles(wrapper);

  if (!giftHandles.length) {
    chooser.hidden = true;
    options.innerHTML = "";
    delete options.dataset.rendered;
    chooser.classList.remove("is-open", "is-locked");
    chooser.dataset.wasEligible = "false";
    return;
  }  

  ensureGiftAccordion(chooser);

  const titleEl = chooser.querySelector(".gift-chooser__title");
  const lockedTpl = titleEl?.dataset.lockedText || "";
  const unlockedText = titleEl?.dataset.unlockedText || "";

  const moneyFormat = wrapper.dataset.moneyFormat || "{{amount}}";
  const giftThreshold = resolveThreshold(wrapper, "giftThresholds", currency);

  // Missing config -> hide entire gift section
  if (!Number.isFinite(giftThreshold) || !giftHandles.length) {
    chooser.hidden = true;
    options.innerHTML = "";
    delete options.dataset.rendered;
    chooser.classList.remove("is-locked", "is-open");
    chooser.dataset.wasEligible = "false";
    return;
  }

  // Config exists -> show gift section always
  chooser.hidden = false;

  const effectiveTotal = getCartTotalExcludingGift(cart);
  const eligible = effectiveTotal >= giftThreshold;
  const existingGift = findGift(cart);

  const remainingForGift = Math.max(giftThreshold - effectiveTotal, 0);
  const remainingForGiftFormatted = formatMoney(remainingForGift, moneyFormat);

  const toggle = chooser.querySelector(".gift-chooser__toggle");
  const panel = chooser.querySelector(".gift-chooser__panel");

  // ----------------------------
  // LOCKED
  // ----------------------------
  if (!eligible) {
    chooser.classList.add("is-locked");
    if (titleEl) {
      const targetGoalFormatted = formatMoney(giftThreshold, moneyFormat);
      const remainingFormatted = remainingForGiftFormatted;

      let lockedText = lockedTpl
        .replace("[remaining_for_gift]", `<strong>${remainingFormatted}</strong>`)
        .replace("[target_goal]", `<strong>${targetGoalFormatted}</strong>`);

      titleEl.innerHTML = lockedText;
    }

    // Mark not eligible so "open once" will work later
    chooser.dataset.wasEligible = "false";
    chooser.dataset.userClosed = "false"; // reset

    // Keep accordion closed by default while locked
    if (panel && toggle) {
      chooser.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      panel.hidden = true;
    }

    // Render cards once (greyed by CSS via .is-locked)
    if (options.dataset.rendered !== "locked" && options.dataset.rendered !== "unlocked") {
      options.dataset.rendered = "locked";
      options.innerHTML = `<div class="gift-loading">Loading...</div>`;

      Promise.all(
        giftHandles.map((h) =>
          fetch(`/products/${h}.js`).then((r) => r.json()).catch(() => null)
        )
      )
        .then((products) => {
          const valid = (products || []).filter(Boolean);
          if (!valid.length) {
            chooser.hidden = true;
            options.innerHTML = "";
            delete options.dataset.rendered;
            return;
          }

          options.innerHTML = valid
            .map((p) => {
              const v =
                (p.variants || []).find((vv) => vv.available) || (p.variants || [])[0];
              if (!v || !v.id) return "";

              const img = p.featured_image || (p.images && p.images[0]) || "";
              const label = p.title || p.handle;

              return `
                <button type="button" class="gift-chooser__card" data-variant="${v.id}" tabindex="-1" aria-disabled="true">
                  <span class="gift-chooser__imgwrap">
                    ${img ? `<img src="${img}" alt="${label}" loading="lazy">` : ""}
                  </span>
                </button>
              `;
            })
            .join("");

          bindGiftSlider(wrapper);
        })
        .catch(() => {});
    }

    // Remove existing gift if present
    if (existingGift && !giftBusy) {
      giftBusy = true;
      cartChange(existingGift.key, 0)
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
          setTimeout(fetchCartAndUpdate, 250);
        })
        .catch(() => {})
        .finally(() => {
          giftBusy = false;
        });
    }

    return;
  }

  // ----------------------------
  // UNLOCKED / ELIGIBLE
  // ----------------------------
  chooser.classList.remove("is-locked");
  if (titleEl) titleEl.innerHTML = unlockedText;

  // Auto-open once when they *cross* the threshold (unless user closed it)
  if (panel && toggle) {
    const wasEligible = chooser.dataset.wasEligible === "true";
    const userClosed = chooser.dataset.userClosed === "true";

    if (!wasEligible && !userClosed) {
      chooser.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      panel.hidden = false;
    }

    chooser.dataset.wasEligible = "true";
  }

  // Render options once per wrapper rebuild
  if (options.dataset.rendered === "unlocked") return;

  options.innerHTML = `<div class="gift-loading">Loading...</div>`;

  Promise.all(
    giftHandles.map((h) =>
      fetch(`/products/${h}.js`).then((r) => r.json()).catch(() => null)
    )
  )
    .then((products) => {
      const valid = (products || []).filter(Boolean);
      if (!valid.length) {
        chooser.hidden = true;
        options.innerHTML = "";
        delete options.dataset.rendered;
        return;
      }

      options.innerHTML = valid
        .map((p) => {
          const v =
            (p.variants || []).find((vv) => vv.available) || (p.variants || [])[0];
          if (!v || !v.id) return "";

          const img = p.featured_image || (p.images && p.images[0]) || "";
          const label = p.title || p.handle;

          return `
            <button type="button" class="gift-chooser__card" data-variant="${v.id}">
              <span class="gift-chooser__imgwrap">
                ${img ? `<img src="${img}" alt="${label}" loading="lazy">` : ""}
              </span>
            </button>
          `;
        })
        .join("");

      bindGiftSlider(wrapper);

      // cards render async — re-sync so the gift already in the cart gets
      // its selected state on first paint
      fetchCartAndUpdate();

      // Ensure single click handler
      if (options.__giftHandler) {
        options.removeEventListener("click", options.__giftHandler);
      }

      options.__giftHandler = (e) => {
        const btn = e.target.closest("[data-variant]");
        if (!btn) return;

        e.preventDefault();

        // If somehow locked, do nothing
        if (chooser.classList.contains("is-locked")) return;

        if (giftBusy) return;
        giftBusy = true;
        btn.disabled = true;

        const variantId = parseInt(btn.dataset.variant, 10);
        if (!variantId) {
          giftBusy = false;
          btn.disabled = false;
          return;
        }

        fetch("/cart.js")
          .then((r) => r.json())
          .then((c) => {
            const existing = findGift(c);

            // Same selection -> no-op
            if (existing && existing.variant_id === variantId) return null;

            // Swap: remove old gift then add new gift
            if (existing) {
              return cartChange(existing.key, 0).then(() => addGift(variantId));
            }
            return addGift(variantId);
          })
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:build"));
            setTimeout(fetchCartAndUpdate, 250);
          })
          .catch(() => {})
          .finally(() => {
            giftBusy = false;
            btn.disabled = false;
          });
      };

      options.addEventListener("click", options.__giftHandler);
      options.dataset.rendered = "unlocked";
    })
    .catch(() => {
      chooser.hidden = true;
      options.innerHTML = "";
      delete options.dataset.rendered;
    });
}

// ----------------------------
// Progress Bars (drawer + page)
// ----------------------------
function updateProgressBars(cart, currency) {
  // cro drawer footer: the "N items" row is static Liquid from page load —
  // keep it (and the gift selected state) in sync on every cart change
  document.querySelectorAll(".cro-cart-count").forEach(function (el) {
    el.textContent = cart.item_count + (cart.item_count === 1 ? " item" : " items");
  });
  const selectedGift = findGift(cart);
  document.querySelectorAll(".gift-chooser__card").forEach(function (card) {
    card.classList.toggle(
      "is-selected",
      !!selectedGift && parseInt(card.dataset.variant, 10) === selectedGift.variant_id
    );
  });

  document.querySelectorAll("#cart-progress-wrapper").forEach((wrapper) => {
    const bar = wrapper.querySelector("#cart-progress-bar");
    const msg = wrapper.querySelector(".goal-message");

    const moneyFormat = wrapper.dataset.moneyFormat || "{{amount}}";

    const preTpl      = wrapper.dataset.preGoalMessageTemplate || "";
    const midTpl      = wrapper.dataset.midGoalMessageTemplate || "";
    const postGoalMsg = wrapper.dataset.postGoalMessage || "";
    const postShipMsg = wrapper.dataset.postShipMessage || ""; // data-post-ship-message

    // Thresholds (now with INT fallback if currency missing)
    const shipThreshold = resolveThreshold(wrapper, "thresholds", currency);
    const giftThreshold = resolveThreshold(wrapper, "giftThresholds", currency);

    // Threshold 0 for a currency (Rory 22-10, GBP) = free shipping on every
    // order: no shipping stage, the bar is the gift stage alone (and nothing
    // at all when there is no gift stage either). No threshold at all (Rory
    // 30-10: international orders lost free shipping, the gift stays) = the
    // same gift-only bar, without any free-shipping wording
    const freeShipAll = shipThreshold === 0;
    const noFreeShip = !Number.isFinite(shipThreshold) || shipThreshold < 0;
    const giftOn = getGiftHandles(wrapper).length > 0 && Number.isFinite(giftThreshold) && giftThreshold > 0;
    // Empty cart OR no shipping stage and no gift stage → hide module
    if (!cart.item_count || ((freeShipAll || noFreeShip) && !giftOn)) {
      wrapper.classList.remove("is-visible", "full");
      if (bar) bar.style.width = "0%";
      if (msg) msg.innerHTML = "";

      const markersWrap = wrapper.querySelector(".cart-progress-markers");
      if (markersWrap) markersWrap.style.display = "none";

      const chooser = wrapper.querySelector(".gift-chooser");
      const options = wrapper.querySelector(".gift-chooser__options");
      if (chooser) {
        chooser.hidden = true;
        chooser.classList.remove("is-open", "is-locked");
        chooser.dataset.wasEligible = "false";
      }
      if (options) {
        options.innerHTML = "";
        delete options.dataset.rendered;
      }
      // free shipping for everyone: the "Shipping  FREE" row stays on
      document.querySelectorAll(".cro-cart-shipping").forEach(function (r) { r.hidden = !(cart.item_count && freeShipAll); });
      return;
    }

    wrapper.classList.add("is-visible");

    // Exclude gift line from totals
    const effectiveTotal = getCartTotalExcludingGift(cart);
    // the shipping goal the bar works with (none = 0, so it starts at the gift stage)
    const shipGoal = noFreeShip ? 0 : shipThreshold;

    // Gift is enabled if handles exist AND gift threshold exists
    const giftHandles = getGiftHandles(wrapper);

    const giftEnabled =
      giftHandles.length > 0 &&
      Number.isFinite(giftThreshold) &&
      giftThreshold > 0;

    // cro only: keep the WHOLE gift stage hidden until free shipping is reached,
    // and render the bar as two clearly-separated stages. Live = unchanged
    // (croCart is false there, so effectiveGiftEnabled === giftEnabled).
    const croCart = document.body.classList.contains("cro-surface");
    const effectiveGiftEnabled = giftEnabled && !(croCart && effectiveTotal < shipGoal);

    // cro: reveal the "Shipping  FREE" footer row once free shipping unlocks
    if (croCart) {
      const shipFree = !noFreeShip && effectiveTotal >= shipThreshold;
      document.querySelectorAll(".cro-cart-shipping").forEach(function (row) {
        row.hidden = !shipFree;
      });
    }

    wrapper.classList.toggle("shipping-only", !effectiveGiftEnabled);
    wrapper.classList.toggle("ship-all-free", freeShipAll);
    wrapper.classList.toggle("no-free-ship", noFreeShip);

    const finalGoal = effectiveGiftEnabled ? giftThreshold : shipThreshold;

    // two-segment gap position (cro CSS draws a gap at the ship mark)
    if (effectiveGiftEnabled && !freeShipAll && !noFreeShip && Number.isFinite(finalGoal) && finalGoal > 0) {
      wrapper.style.setProperty("--cro-ship-pct", `${(shipThreshold / finalGoal) * 100}%`);
    } else {
      wrapper.style.removeProperty("--cro-ship-pct");
    }

    // Markers (hide gift marker automatically when the gift stage is off)
    updateProgressMarkers(wrapper, shipGoal, effectiveGiftEnabled ? giftThreshold : null, moneyFormat);

    // Bar fill
    const pct = Math.min((effectiveTotal / finalGoal) * 100, 100);
    if (bar) bar.style.width = `${pct}%`;
    wrapper.classList.toggle("full", pct >= 100);

    // Messages
    let message = "";

    if (effectiveTotal < shipGoal) {
      const remaining = shipThreshold - effectiveTotal;
      const formatted = formatMoney(remaining, moneyFormat);
      message = preTpl.replace("[remaining_for_goal]", `<strong>${formatted}</strong>`);
    } else if (effectiveGiftEnabled && effectiveTotal < giftThreshold) {
      const remaining = giftThreshold - effectiveTotal;
      const formatted = formatMoney(remaining, moneyFormat);
      message = (noFreeShip ? CRO_GIFT_ONLY_MID : midTpl).replace("[remaining_for_goal]", `<strong>${formatted}</strong>`);
    } else if (noFreeShip) {
      message = CRO_GIFT_ONLY_POST;
    } else {
      // Reached shipping (and gift if enabled)
      message = effectiveGiftEnabled ? postGoalMsg : (postShipMsg || postGoalMsg);
    }

    if (msg) msg.innerHTML = message;

    // Gift UI
    const chooser = wrapper.querySelector(".gift-chooser");
    const options = wrapper.querySelector(".gift-chooser__options");

    if (effectiveGiftEnabled) {
      if (typeof updateGiftUI === "function") updateGiftUI(wrapper, cart, currency);
    } else {
      if (chooser) {
        chooser.hidden = true;
        chooser.classList.remove("is-open", "is-locked");
        chooser.dataset.wasEligible = "false";
      }
      if (options) {
        options.innerHTML = "";
        delete options.dataset.rendered;
      }
    }
  });
}

// ----------------------------
// Fetch + Events
// ----------------------------
function fetchCartAndUpdate() {
  return fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      updateProgressBars(cart, cart.currency);
      return cart;
    })
    .catch(() => {});
}

document.addEventListener("DOMContentLoaded", fetchCartAndUpdate);

document.addEventListener("cart:updated", (e) => {
  const c = e.detail && e.detail.cart;
  if (c && typeof c.total_price !== "undefined") {
    updateProgressBars(c, c.currency);
  } else {
    fetchCartAndUpdate();
  }
});

document.addEventListener("ajaxProduct:added", () => {
  document.dispatchEvent(new CustomEvent("cart:build"));
  setTimeout(fetchCartAndUpdate, 250);
});

/* cro-pdp only: collapse consecutive <br> in tab metafield content so the
   double line breaks (blank lines) become a single break. Runs client-side
   so it works regardless of page/template cache. */
(function () {
  function isCro() {
    return document.body && document.body.className.indexOf("template-product-cro-pdp") !== -1;
  }
  // Tab metafield text: split on <br> runs and wrap each line in a block .cro-line
  // so the spacing between lines is controllable via CSS (2px) instead of relying
  // on <br> height (which browsers ignore).
  function collapseCroBrs() {
    if (!isCro()) return;
    var nodes = document.querySelectorAll(".template-product-cro-pdp .product-block--tab .metafield-multi_line_text_field");
    nodes.forEach(function (el) {
      if (el.getAttribute("data-cro-lined")) return;
      var parts = el.innerHTML.split(/(?:<br\s*\/?>\s*)+/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (parts.length) {
        el.innerHTML = parts.map(function (t) { return '<span class="cro-line">' + t + "</span>"; }).join("");
        el.setAttribute("data-cro-lined", "1");
      }
    });
  }
  // cro-pdp mobile: build the rising content panel. Ensure the frosted divider
  // exists at the top of the content column, then move the title/price
  // (.mobile_title) out of the gallery column into the panel (after the
  // divider) so the gallery can pin and the whole info panel scrolls over it.
  function setupCroMobilePanel() {
    if (!isCro()) return;
    if (!window.matchMedia || !window.matchMedia("(max-width: 768px)").matches) return;
    var contentCol = document.querySelector(".template-product-cro-pdp .grid__item.medium-up--two-fifths");
    if (!contentCol) return;
    var divider = contentCol.querySelector(".mp2__gallery-divider-mob");
    if (!divider) {
      divider = document.createElement("div");
      divider.className = "mp2__gallery-divider-mob";
      divider.setAttribute("aria-hidden", "true");
      contentCol.insertBefore(divider, contentCol.firstChild);
    }
    var mt = document.querySelector(".template-product-cro-pdp .mobile_title");
    if (mt && divider.nextElementSibling !== mt) {
      divider.insertAdjacentElement("afterend", mt);
    }
  }
  // cro-pdp mobile: as you scroll, progressively blur the (pinned) gallery via
  // a backdrop-filter overlay that sits over the gallery, behind the content.
  function setupCroGalleryBlur() {
    if (!isCro()) return;
    if (!window.matchMedia || !window.matchMedia("(max-width: 768px)").matches) return;
    var gallery = document.querySelector(".template-product-cro-pdp .product-single__sticky");
    if (!gallery || gallery.querySelector(".cro-gallery-blur")) return;
    var ov = document.createElement("div");
    ov.className = "cro-gallery-blur";
    ov.setAttribute("aria-hidden", "true");
    gallery.appendChild(ov);
    var MAX_BLUR = 8;     // px
    var MAX_WHITE = 0.18; // overlay white tint
    var START = 0.5;      // don't blur until half the first image has scrolled away
    var ticking = false;
    // Progress is measured against the first product image's height (not the whole
    // stacked gallery), so blur stays at 0 while the image is on screen and only
    // kicks in once ~half of it has scrolled away — a slight blur at the top made
    // users think the image hadn't loaded (client feedback).
    function refHeight() {
      var img = gallery.querySelector("img");
      var h = img ? img.getBoundingClientRect().height : 0;
      return h > 40 ? h : (gallery.getBoundingClientRect().height || window.innerHeight || 1);
    }
    function apply() {
      ticking = false;
      var raw = window.pageYOffset / refHeight();
      var t = Math.min(Math.max((raw - START) / (1 - START), 0), 1); // 0 until 50%, then 0..1 by 100%
      var blur = (t * MAX_BLUR).toFixed(2);
      ov.style.webkitBackdropFilter = "blur(" + blur + "px)";
      ov.style.backdropFilter = "blur(" + blur + "px)";
      ov.style.backgroundColor = "rgba(255,255,255," + (t * MAX_WHITE).toFixed(3) + ")";
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  }
  // cro-pdp: custom same-day-dispatch countdown (the Essential Countdown app
  // stopped injecting). Fills the empty .countdown-timer-block (already placed
  // right under the dynamic button) with a live timer to 2pm GMT, Mon–Fri
  // (Rory 30-10, was 1pm).
  function setupCroDispatchCountdown() {
    if (!isCro()) return;
    var block = document.querySelector(".template-product-cro-pdp .countdown-timer-block");
    if (!block) return;
    // OWN this block: the Essential Countdown app sometimes injects its OWN timer
    // late (after we've filled the empty block), which showed TWO "Order before…"
    // sentences (mine to the cut-off, the app's to noon). Keep our span as the only
    // child and strip anything the app adds.
    var el;
    function ensure() {
      el = block.querySelector(".cro-dispatch");
      if (!el) {
        el = document.createElement("span");
        el.className = "cro-dispatch";
        block.innerHTML = "";
        block.appendChild(el);
      }
      for (var i = block.children.length - 1; i >= 0; i--) {
        if (block.children[i] !== el) block.removeChild(block.children[i]);
      }
    }
    function unit(n, w) { return n + " " + w + (n === 1 ? "" : "s"); }
    function human(h, m, s) {
      // readable "1 hour 38 minutes 58 seconds" (drop leading zero units)
      var parts = [];
      if (h > 0) parts.push(unit(h, "hour"));
      if (h > 0 || m > 0) parts.push(unit(m, "minute"));
      parts.push(unit(s, "second"));
      return parts.join(" ");
    }
    function tick() {
      ensure();
      var now = new Date();
      var c = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 14, 0, 0));
      var day = now.getUTCDay(); // 0 Sun .. 6 Sat
      if (now < c && day >= 1 && day <= 5) {
        // same-day window (weekday before 2pm GMT): live countdown
        var diff = c - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        // the time itself is wrapped so CSS can weight it up (scannability)
        el.innerHTML = "Order in the next <span class=\"cro-dispatch__time\">" + human(h, m, s) + "</span> and we'll ship it today!";
      } else {
        // afternoon / weekend: standard announcement-style message (no huge timer)
        el.textContent = "Order before 2pm GMT (Mon-Fri) for same day dispatch";
      }
    }
    tick();
    setInterval(tick, 1000);
    // instant cleanup if the app injects its markup after us
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (block.children.length > 1) { obs.disconnect(); ensure(); obs.observe(block, { childList: true }); }
      });
      obs.observe(block, { childList: true });
    }
  }
  // cro-pdp mobile: Represent-style sticky add-to-cart bar that appears when the
  // inline ATC scrolls out of view. It mirrors the real ATC's label and proxies
  // the click, so all add-to-cart logic stays with the theme's button.
  function setupCroStickyAtc() {
    if (!isCro()) return;
    if (!window.matchMedia || !window.matchMedia("(max-width: 768px)").matches) return;
    var realAtc = document.querySelector(".template-product-cro-pdp .add-to-cart");
    if (!realAtc || document.querySelector(".cro-sticky-atc")) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cro-sticky-atc";
    btn.setAttribute("aria-label", "Add to cart");
    var label = document.createElement("span");
    btn.appendChild(label);
    document.body.appendChild(btn);
    // sold out with Swym's restock button on the page: the bar reads NOTIFY ME
    // (bell in cro-pdp.css) and opens Swym's sign-up instead of the dead ATC
    function swymNotify() {
      return realAtc.disabled ? document.querySelector(".template-product-cro-pdp .payment-buttons .swym-add-to-watchlist") : null;
    }
    function sync() {
      var notify = !!swymNotify();
      label.textContent = notify ? "Notify me" : (realAtc.textContent || "Add to cart").replace(/\s+/g, " ").trim();
      btn.disabled = !!realAtc.disabled && !notify;
      btn.classList.toggle("cro-notify", notify);
    }
    sync();
    try {
      new MutationObserver(sync).observe(realAtc, { childList: true, subtree: true, attributes: true });
      // Swym injects its button late (after cookie consent); sync() only
      // touches the sticky button, never this container
      var pay = realAtc.closest(".payment-buttons");
      if (pay) new MutationObserver(sync).observe(pay, { childList: true });
    } catch (e) {}
    btn.addEventListener("click", function () {
      var sw = swymNotify();
      if (sw) { sw.click(); return; }
      if (!croSizeSelected()) { croRollSelectSize(btn); croScrollToSizes(); } else { realAtc.click(); }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle("cro-sticky-atc-on", !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(realAtc);
    } else {
      document.body.classList.add("cro-sticky-atc-on");
    }
  }
  // cro-pdp: no size selected by default. If add-to-cart is pressed with no size,
  // scroll to the size selector instead of adding; once a size is chosen, add.
  // Products with no size options (single / default-variant: sunglasses, one-size
  // caps…) render NO size radios — there is nothing to select, so the gate must
  // pass, otherwise the ATC is blocked forever and the product can't be bought.
  function croSizeSelected() {
    var scope = document.querySelector(".template-product-cro-pdp");
    if (!scope) return true;
    if (!scope.querySelector(".variant-input input[type='radio']")) return true;
    return !!scope.querySelector(".variant-input input[type='radio']:checked");
  }
  function croScrollToSizes() {
    var w = document.querySelector(".template-product-cro-pdp .variant-input-wrap");
    if (w) {
      var label = w.closest(".product-block") || w;
      label.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
  // Represent-style feedback: roll a "Select size" message over the ATC, then
  // reveal the original label again. Overlay (not a text swap) so the theme's
  // own label updates are never disturbed.
  function croRollSelectSize(btn) {
    if (!btn || btn.querySelector(".cro-atc-rollmsg")) return;
    if (getComputedStyle(btn).position === "static") btn.style.position = "relative";
    var prevOverflow = btn.style.overflow;
    btn.style.overflow = "hidden";
    var msg = document.createElement("span");
    msg.className = "cro-atc-rollmsg";
    msg.textContent = "Select size";
    msg.setAttribute("aria-hidden", "true");
    var bg = getComputedStyle(btn).backgroundColor;
    if (bg && bg !== "rgba(0, 0, 0, 0)" && bg !== "transparent") msg.style.background = bg;
    btn.appendChild(msg);
    msg.addEventListener("animationend", function () {
      msg.remove();
      btn.style.overflow = prevOverflow;
    });
  }
  function setupCroSizeGate() {
    if (!isCro()) return;
    // deselect the pre-selected (default) size so nothing is chosen on load
    var checked = document.querySelector(".template-product-cro-pdp .variant-input input[type='radio']:checked");
    if (checked) checked.checked = false;
    // gate the inline ATC: block add + scroll to sizes when none selected
    var realAtc = document.querySelector(".template-product-cro-pdp .add-to-cart");
    if (realAtc && !realAtc.getAttribute("data-cro-gate")) {
      realAtc.setAttribute("data-cro-gate", "1");
      realAtc.addEventListener("click", function (e) {
        if (!croSizeSelected()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          croRollSelectSize(realAtc);
          croScrollToSizes();
        }
      }, true);
    }
  }
  // cro-pdp: the AJAX add-to-cart takes a moment; without feedback the button
  // looks stuck. Show a spinner on the ATC (and the sticky ATC) from click
  // until the cart drawer opens (or a safety timeout).
  function croStopSpinner() {
    var nodes = document.querySelectorAll(".cro-atc-loading");
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove("cro-atc-loading");
  }
  function croStartSpinner() {
    var real = document.querySelector(".template-product-cro-pdp .add-to-cart");
    if (real) real.classList.add("cro-atc-loading");
    var sticky = document.querySelector(".cro-sticky-atc");
    if (sticky) sticky.classList.add("cro-atc-loading");
    clearTimeout(window.__croSpinT);
    window.__croSpinT = setTimeout(croStopSpinner, 8000);
  }
  function setupCroAtcSpinner() {
    if (!isCro()) return;
    var realAtc = document.querySelector(".template-product-cro-pdp .add-to-cart");
    if (!realAtc || realAtc.getAttribute("data-cro-spin")) return;
    realAtc.setAttribute("data-cro-spin", "1");
    // bubble phase: runs after the capture-phase size gate, so a blocked add
    // (no size selected) never reaches here; guard with croSizeSelected too.
    realAtc.addEventListener("click", function () {
      if (croSizeSelected()) croStartSpinner();
    });
    var drawer = document.getElementById("CartDrawer");
    if (drawer && "MutationObserver" in window) {
      new MutationObserver(function () {
        if (drawer.classList.contains("drawer--is-open")) croStopSpinner();
      }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
    }
    document.addEventListener("cart:updated", croStopSpinner);
    document.addEventListener("ajaxProduct:added", croStopSpinner);
  }
  // cro-pdp: our own "Find my ideal size" link (replaces the Size Guide) opens
  // the Kleep drawer. Kleep re-renders/manages its own button, so instead of
  // reusing it we call Kleep's CTA handler directly (falling back to the native
  // button click). The link markup lives in product-template.liquid; the native
  // Kleep button is hidden via CSS.
  function openKleepDrawer() {
    try {
      if (window.KleepSDK && typeof window.KleepSDK.__onMainCta === "function") {
        window.KleepSDK.__onMainCta();
        return;
      }
    } catch (e) {}
    var b = document.querySelector(".kleep-button");
    if (b) b.click();
  }
  function setupCroKleepLink() {
    if (!isCro()) return;
    var link = document.querySelector(".template-product-cro-pdp [data-cro-kleep]");
    if (!link || link.getAttribute("data-cro-bound")) return;
    link.setAttribute("data-cro-bound", "1");
    link.addEventListener("click", function (e) {
      e.preventDefault();
      openKleepDrawer();
    });
  }
  // cro-pdp mobile: the gallery is a Flickity slider; on iOS its touch handling
  // often swallows the native click on the absolutely-positioned "+" zoom button
  // inside a cell, so PhotoSwipe never opens. IMPORTANT LESSON (previous attempt):
  // we must NOT preventDefault/stopPropagation on the touch events — Flickity
  // needs the FULL touch sequence or its pointer state gets stuck ("finger still
  // down"), which froze the slider after a zoom and killed later taps. So:
  // listen passively (never interfere), detect a clean tap on any zoom button
  // (delegated — covers cloned/re-rendered cells), and if the browser doesn't
  // deliver the native click shortly after, fire the button's click ourselves.
  // A shared dedupe gate makes native + synthetic + iOS ghost clicks fire once.
  function setupCroZoomTap() {
    if (!isCro()) return;
    if (!window.matchMedia || !window.matchMedia("(max-width: 768px)").matches) return;
    if (document.documentElement.getAttribute("data-cro-zoomtap")) return;
    document.documentElement.setAttribute("data-cro-zoomtap", "1");
    var ZOOM = ".template-product-cro-pdp .js-photoswipe__zoom";
    var startBtn = null, sx = 0, sy = 0, moved = false;
    var lastFire = 0, firing = false;
    function zoomFrom(el) { return el && el.closest ? el.closest(ZOOM) : null; }
    function fire(btn) {
      if (Date.now() - lastFire < 600) return; // native click already handled it
      lastFire = Date.now();
      firing = true;
      try { btn.click(); } finally { firing = false; }
    }
    document.addEventListener("touchstart", function (e) {
      var t = e.changedTouches[0];
      startBtn = zoomFrom(e.target); sx = t.clientX; sy = t.clientY; moved = false;
    }, { passive: true, capture: true });
    document.addEventListener("touchmove", function (e) {
      if (!startBtn) return;
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) moved = true;
    }, { passive: true, capture: true });
    document.addEventListener("touchcancel", function () { startBtn = null; }, { passive: true, capture: true });
    document.addEventListener("touchend", function () {
      var btn = startBtn; startBtn = null;
      if (!btn || moved) return;
      // give the native click ~320ms to arrive; fire ourselves only if it doesn't
      setTimeout(function () { fire(btn); }, 320);
    }, { passive: true, capture: true });
    document.addEventListener("click", function (e) {
      if (firing) return;                    // our synthetic click — let it through
      var btn = zoomFrom(e.target);
      if (!btn) return;
      if (Date.now() - lastFire < 600) {     // ghost/duplicate after we fired
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      lastFire = Date.now();                 // native click wins; pending synthetic no-ops
    }, { capture: true });
  }
  // cro-pdp-d desktop: the gallery "+" buttons are hidden and the image itself
  // is the zoom trigger. NOTE: the desktop gallery snippet
  // (custom-product-images.liquid) already forwards a click on any visible
  // slide to the hidden slider's PhotoSwipe button. A second proxy here opened
  // a SECOND PhotoSwipe instance on the same .pswp element; on close, that
  // instance restored the class list it had captured at creation (with
  // pswp--open), leaving an invisible full-page overlay that blocked every
  // click until reload (client report, Oct 2026). So: no JS here — the cursor
  // comes from cro-pdp-desktop.css and the click is handled by the snippet.
  // cro-pdp-d: "More colours" side panel (Represent-style). Markup only
  // renders on the -d template when there are >6 sibling colours.
  function setupCroColorsModal() {
    var modal = document.querySelector("[data-cro-colors-modal]");
    if (!modal || modal.getAttribute("data-cro-bound")) return;
    modal.setAttribute("data-cro-bound", "1");
    // portal to <body>: rendered inside the meta column the fixed panel gets
    // trapped in an ancestor stacking context and the header draws over it
    document.body.appendChild(modal);
    document.querySelectorAll("[data-cro-colors-open]").forEach(function (b) {
      b.addEventListener("click", function () {
        modal.hidden = false;
        document.documentElement.classList.add("cro-colors-modal-open");
      });
    });
    modal.querySelectorAll("[data-cro-colors-close]").forEach(function (b) {
      b.addEventListener("click", function () {
        modal.hidden = true;
        document.documentElement.classList.remove("cro-colors-modal-open");
      });
    });
  }
  // cro-pdp-d: the size box outline is drawn by the per-cell rings (no
  // container border) so it hugs an incomplete last row. CSS can't know
  // which cell ends the first row / starts the last one, so mark the four
  // corner cells here and recompute when wrapping changes on resize.
  function setupCroSizeCorners() {
    if (!document.body || document.body.className.indexOf("template-product-cro-pdp-d") === -1) return;
    var wraps = document.querySelectorAll(".variant-input-wrap");
    if (!wraps.length) return;
    function apply() {
      wraps.forEach(function (wrap) {
        var cells = Array.prototype.filter.call(wrap.children, function (el) {
          return el.classList.contains("variant-input") && el.offsetParent !== null;
        });
        cells.forEach(function (c) {
          var l = c.querySelector(".variant__button-label");
          if (l) l.classList.remove("cro-sz-tl", "cro-sz-tr", "cro-sz-bl", "cro-sz-br");
        });
        if (!cells.length) return;
        var firstTop = cells[0].offsetTop;
        var lastTop = cells[cells.length - 1].offsetTop;
        cells.forEach(function (c, i) {
          var l = c.querySelector(".variant__button-label");
          if (!l) return;
          var top = c.offsetTop;
          var rowStart = i === 0 || cells[i - 1].offsetTop !== top;
          var rowEnd = i === cells.length - 1 || cells[i + 1].offsetTop !== top;
          if (top === firstTop && rowStart) l.classList.add("cro-sz-tl");
          if (top === firstTop && rowEnd) l.classList.add("cro-sz-tr");
          if (top === lastTop && rowStart) l.classList.add("cro-sz-bl");
          if (top === lastTop && rowEnd) l.classList.add("cro-sz-br");
        });
      });
    }
    apply();
    var t = null;
    window.addEventListener("resize", function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    }, { passive: true });
  }
  function run() {
    collapseCroBrs();
    setupCroMobilePanel();
    setupCroGalleryBlur();
    setupCroDispatchCountdown();
    setupCroSizeGate();
    setupCroStickyAtc();
    setupCroAtcSpinner();
    setupCroKleepLink();
    setupCroZoomTap();
    setupCroColorsModal();
    setupCroSizeCorners();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
/* CookieYes blocking modal: lock page scroll while the consent banner is
   visible (the banner itself is restyled into a full-screen overlay in
   custom.css). CookieYes injects async and hides via class/inline style,
   so watch the container and mirror its visibility onto html. */
(function () {
  var seen = null;
  function visible(el) {
    return el && getComputedStyle(el).display !== "none" && !el.classList.contains("cky-hide");
  }
  function sync() {
    var c = document.querySelector(".cky-consent-container");
    document.documentElement.classList.toggle("cky-modal-open", visible(c));
    if (c && c !== seen) {
      seen = c;
      new MutationObserver(sync).observe(c, {
        attributes: true,
        attributeFilter: ["class", "style"],
      });
    }
  }
  function boot() {
    sync();
    /* container may not exist yet — watch for the injection, then stop */
    if (!seen) {
      var mo = new MutationObserver(function () {
        if (document.querySelector(".cky-consent-container")) {
          sync();
          mo.disconnect();
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* CookieYes first layer, Represent's pattern (Alex 26-10): the reject CTA
   reads PREFERENCES and opens CookieYes's preference center (Reject all lives
   on inside it). CookieYes re-renders its banner, so the button is tagged
   once and re-tagged only if replaced (no observer feedback). */
(function () {
  function tag() {
    var btn = document.querySelector(".cky-consent-container .cky-notice-btn-wrapper .cky-btn-reject");
    if (!btn || btn.getAttribute("data-clab-pref")) return;
    btn.setAttribute("data-clab-pref", "1");
    btn.textContent = "PREFERENCES";
    btn.setAttribute("aria-label", "PREFERENCES");
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof window.revisitCkyConsent === "function") window.revisitCkyConsent();
    }, true);
  }
  function boot() {
    tag();
    new MutationObserver(tag).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* Drawer "Remove" fix: the link in cart-item.liquid is plain navigation to
   /cart/change?id=...&quantity=0, which dumps the user on /cart. The theme's
   own qty path can't reach zero either (quantityChanged guards !qty), so
   inside the drawer we intercept the click and run the same AJAX flow as the
   steppers: changeItem -> rebuild markup (cart:build) -> sync progress/gift/
   count (cart:updated). The /cart PAGE keeps the native full-reload link,
   and any failure falls back to it. */
(function () {
  document.addEventListener("click", function (e) {
    var link = e.target.closest(".cart__remove a");
    if (!link || !link.closest("#CartDrawer")) return;
    e.preventDefault();
    var m = (link.getAttribute("href") || "").match(/[?&]id=([^&]+)/);
    if (!m || !window.theme || !theme.cart || !theme.cart.changeItem) {
      window.location.href = link.href;
      return;
    }
    var item = link.closest(".cart__item") || link.closest("[data-key]");
    if (item) item.classList.add("is-loading");
    theme.cart
      .changeItem(decodeURIComponent(m[1]), 0)
      .then(function (cart) {
        var form = document.getElementById("CartDrawerForm");
        if (form && form.parentNode) {
          form.parentNode.classList.toggle("is-empty", cart.item_count === 0);
        }
        /* drawer header subtotal (the "(€193,95)" next to the title) */
        var sub = document.querySelector("#CartDrawer [data-subtotal]");
        if (sub && window.theme && theme.Currency && theme.settings) {
          sub.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat);
        }
        document.dispatchEvent(new CustomEvent("cart:build"));
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });
})();
